import { keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { parseAnonymousLearningItem } from '../../models/AnonymousLearningItem'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsLearningItems } from '../useInvalidate'

export default function useLearningItemSuggestions(init?: string | null, type?: string[]) {
  const [query, setQuery] = useState(init)
  const [typeQuery, _setTypeQuery] = useState(type)

  const [currentQuery, debounceState] = useDebounce(query, 300)
  const [currentType, _debounceStateType] = useDebounce(typeQuery, 300)

  const result = useApiQuery({
    queryKey: ['learningItemSuggestions', ReturnsLearningItems, currentQuery, currentType],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      parseAnonymousLearningItem
        .array(
          (
            await api.get(
              `course?page=1&page_size=10&search=${encodeURIComponent(currentQuery || '')}&type=${encodeURIComponent(
                (currentType && currentType.join(',')) || ''
              )}`
            )
          )?.data
        )
        .filter(({ error }) => !error),
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
